export default {
  nav: {
    home: '首页',
    assessment: '测评中心',
    faq: '常见问题',
    contact: '联系我们',
    login: '登录',
    personalCenter: '个人中心'
  },
  hero: {
    title1: '网班',
    title2: '汉语快速测评',
    sub: 'Chinese Proficiency Quick Test',
    start: '进入测试',
    tagWrite: '写字能力',
    tagSpeak: '语音型',
    tagRead: '阅读数',
    aiBadge: 'AI 智能汉语评测'
  },
  whatIs: {
    title: '什么是CPQT？',
    p1: '汉语水平快速测评平台融合人工智能、自然语言处理、智能语音识别等先进技术，围绕学习者真实语言应用能力，',
    p2: '提供快速、客观、精准的汉语水平评估。平台突破传统考试模式，通过智能评分、多维分析、数据反馈等能力，',
    p3: '为学校、培训机构及学习者提供可信赖的测评结果，为教学优化和学习提升提供科学依据。',
    viewMore: '查看更多'
  },
  whoWill: {
    title: '哪些人适合参加评测？',
    subtitle: '满足不同学习阶段、不同应用场景的汉语能力评价需求。',
    itemsHeader: [
      '国际学生',
      '高校学生',
      '汉语学习者',
      '学校及教育机构',
      '企事业单位'
    ],
    items: [
      '为来华留学提供汉语能力参考',
      '辅助课程学习、阶段测评和学习诊断',
      '快速了解自身汉语水平，为学习交流做好准备',
      '全面掌握学生学习情况，为教学提供数据支撑',
      '开展员工汉语能力评估，满足国际化人才培养需求'
    ],
  },
  philosophy: {
    title: '我们的理念',
    sub: '让评测更智能，让学习更高效',
    btn: '进入测试'
  },
  howTo: {
    title: '如何完成评测？',
    desc1: '全程在线，仅需约30分钟，即可完成汉语能力快速测评。',
    desc2: '',
    scenario: 'Scenario',
    scenarioA: '登录平台',
    scenarioB: '完成测评',
    scenarioC: '查看报告',
    descA: '注册账号，进入评测系统',
    descB: '按照提示完成听力、口语及综合能力测评',
    descC: '系统自动生成评测报告，全面分析学习情况',
    minutes: '分钟'
  },
  faqSection: {
    title: '常见问题',
    q1: 'NBCFA有哪些独特优势？',
    a1: 'NBCFA采用AI自适应测评技术，测评时间短、结果精准，提供多维度能力分析报告，并给出个性化学习建议。',
    q2: 'NBCFA测试需要多长时间？',
    a2: '标准测评约30分钟，包含三个场景模块：听力理解与回应、学术互动、学术阅读与写作。',
    q3: '需要什么设备？',
    a3: '只需一台电脑和一副耳机即可在线完成全部测评，无需安装额外软件。',
    viewMore: '查看更多'
  },
  footer: {
    quickLinks: '快速链接',
    home: '首页',
    aboutCepa: '关于 CPQT',
    startTest: '开始测试',
    support: '支持',
    contact: '联系我们',
    servicePolicy: '服务政策',
    faq: '常见问题',
    copyright: 'A NETCLASS Company (Nasdaq: NTCL) Copyright © 2026 NBCFA. All rights reserved.'
  },
  login: {
    welcome: '欢迎登录',
    subtitle1: '网班',
    subtitle2: '汉语水平快速测评中心',
    loginTitle: '登录',
    registerTitle: '注册',
    username: '用户名',
    usernamePh: '请输入用户名',
    email: '邮箱',
    emailPh: '请输入邮箱',
    password: '密码',
    passwordPh: '请输入密码',
    confirmPassword: '确认密码',
    confirmPasswordPh: '请再次输入密码',
    submit: '登录',
    submitReg: '注册',
    loading: '请稍候...',
    noAccount: '还没有账号？',
    hasAccount: '已有账号？',
    goRegister: '立即注册',
    goLogin: '去登录',
    pwdMismatch: '两次密码不一致',
    pwdTooShort: '密码至少6个字符',
    usernameTooShort: '用户名至少3个字符',
    usernameInvalid: '用户名只能包含字母、数字和下划线',
    emailInvalid: '请输入正确的邮箱地址',
    required: '此项不能为空',
    networkError: '网络错误，请稍后重试',
    registerSuccess: '注册成功，请登录'
  },
  user: {
    personalData: '个人数据',
    myTests: '我的测试',
    profile: '个人资料',
    logout: '退出登录',
    currentLevel: '当前等级',
    totalTests: '测试总数',
    bestLevel: '最佳等级',
    testsHistory: '测试历史',
    testDate: '测试日期',
    testId: '测试编号',
    score: '分数',
    grade: '等级',
    duration: '时长',
    status: '状态',
    report: '报告',
    action: '操作',
    completed: '已完成',
    inProgress: '进行中',
    aborted: '提前中止',
    pending: '待处理',
    viewReport: '查看报告',
    noRecords: '暂无测试记录',
    minutes: '分钟',
    username: '用户名',
    email: '邮箱',
    familyName: '姓',
    familyNamePh: '请输入姓',
    givenName: '名',
    givenNamePh: '请输入名',
    currentPassword: '当前密码',
    newPassword: '新密码',
    newPasswordHint: '至少6个字符，需包含字母和数字的组合',
    confirmPassword: '确认密码',
    gender: '性别',
    male: '男',
    female: '女',
    birthday: '生日',
    country: '国家/地区（可选）',
    countryPh: '请选择国家',
    saveChanges: '保存更改',
    saving: '保存中...',
    saveSuccess: '保存成功',
    saveFail: '保存失败'
  },
  assessment: {
    notice: '测评注意事项',
    noticeDesc: '同学你好，请评估您参与本次评测的时间，并预留好时间。本次测评不支持中途退出，如果退出，则不计入评测成绩，需您重新完成评测。',
    phase1: '听力理解（5分钟）',
    phase2: '口语表达（5分钟）',
    phase3: '阅读测评（5分钟）',
    phase4: '书写能力（5分钟）',
    startBtn: '开始智能测评',
    inProgress: '测评进行中',
    holdToSpeak: '按住说话',
    waitForPlay: '请等待题目播放',
    reRecord: '重录',
    confirmSend: '确认发送',
    resultTitle: '测评结果',
    close: '关闭',
    exitTitle: '确认退出测评？',
    exitDesc: '退出后将立即中止测评并给出最终分数，此操作不可撤销。',
    continueExam: '继续测评',
    confirmExit: '确认退出',
    roundNum: '第{n}题',
    toastStartFailed: '开始测评失败: ',
    toastPlayFailed: '播放录音失败',
    toastNoRecording: '没有可发送的录音',
    toastSubmitFailed: '提交答案失败: ',
    toastNextFailed: '获取下一题失败，请重试',
    toastResultFailed: '获取结果失败: ',
    inputPh: '请输入您的答案',
    finished: '测评已完成，感谢您的参与！',
    finishedMsg: '测评已完成！感谢您的参与，我们将尽快为您生成评测报告。',
    viewResult: '查看结果',
    backHome: '返回首页',
    exitConfirm: '测评正在进行中，退出后将基于当前已完成的题目计算分数，未完成的题目将记为0分。确定要结束本次测评吗？',
    intro1: '第一部分为听力理解测评，您将听到一段情境描述和问题，请用语音作答。下面，我们开始听力理解测评。',
    intro2: '恭喜您，完成了第一部分。下面进入第二部分口语表达测评，您将看到一段文字，请用语音朗读出来。',
    intro3: '恭喜您，完成了第二部分。下面进入第三部分阅读理解测评，您将看到一段阅读材料，请用语音回答问题。',
    intro4: '恭喜您，完成了第三部分。下面进入第四部分书写能力测评，请用电脑键盘输入您的答案。',
    sideTitle: '汉语水平评测',
    q1_1: '请听以下语音并复述内容',
    q1_2: '请听以下语音并回答问题',
    q2_1: '请回答以下问题：您的家乡在哪里？',
    q2_2: '请回答以下问题：下面这段话，作者表达了什么意思？',
    q2_3: '请回答以下问题：您的家乡在哪里？',
    q3_1: '请回答以下问题：您的家乡在哪里？',
    q3_2: '这个"单"的拼音是什么？',
    q3_3: '请输入一段描写你家乡的美食的话，字数为400字'
  },
  report: {
    congrats: '恭喜您，完成了汉语水平快速评测，',
    subtitle: '以下是您本次评测的报告',
    abortedTitle: '测评已终止',
    abortedSubtitle: '您已中途退出测评，以下是已完成的题目成绩',
    download: '下载报告',
    certTitle: '汉 语 水 平 考 试',
    levelLabel: '（六级）成绩报告',
    name: '姓名：',
    gender: '性别：',
    nationality: '国籍：',
    examDate: '考试时间：',
    year: '年',
    month: '月',
    day: '日',
    examNo: '编号：',
    ticketNo: '准考证号：',
    fullScore: '满分',
    yourScore: '你的分数',
    listening: '听力',
    oral: '口语',
    reading: '阅读',
    writing: '书写',
    totalScore: '总分',
    gradeLabel: '综合等级',
    radarGrammar: '语法',
    radarVocab: '词汇',
    radarSpeaking: '口语',
    director: '主任：',
    org: '教育部中外语言交流合作中心',
    location: '中国·上海',
    backHome: '返回首页'
  },
  faq: {
    title: '常见问题',
    list: [
      { q: 'NBCFA 有哪些独特优势？', a: 'NBCFA 采用 AI 自适应测评技术，测评时间短、结果精准，提供多维度能力分析报告，并给出个性化学习建议。' },
      { q: 'NBCFA 测评需要多长时间？', a: '标准测评约 30 分钟，包含四个模块：听力理解、口语表达、阅读理解、书写表达。' },
      { q: '需要什么设备？', a: '只需一台电脑和一副耳机即可在线完成全部测评，无需安装额外软件。' },
      { q: 'NBCFA 的评分标准是什么？', a: '评分基于 AI 多维度分析，包括发音准确度、流利度、内容完整性和语言表达能力，综合生成能力等级报告。' },
      { q: '测评结果多久可以查看？', a: '测评完成后即时生成结果报告，可在个人中心查看详细的能力分析和学习建议。' },
      { q: '是否支持多次测评？', a: '支持多次测评，系统会记录每次测评结果，方便追踪学习进度和能力提升情况。' }
    ]
  }
}
